import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const OrganisationConnection = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M18 9.00002C18 11.415 19.721 13.435 22 13.899V18.1C20.044 18.499 18.499 20.043 18.101 21.999H14.75C12.131 21.999 10 19.868 10 17.249V13.898C12.279 13.434 14 11.413 14 8.99902C14 6.24202 11.757 3.99902 9 3.99902C6.243 3.99902 4 6.24202 4 8.99902C4 11.414 5.721 13.434 8 13.898V17.249C8 20.971 11.028 23.999 14.75 23.999H18.101C18.566 26.278 20.586 27.999 23 27.999C25.757 27.999 28 25.756 28 22.999C28 20.584 26.279 18.564 24 18.1V13.899C26.279 13.435 28 11.414 28 9.00002C28 6.24302 25.757 4.00002 23 4.00002C20.243 4.00002 18 6.24302 18 9.00002ZM6 9.00002C6 7.34602 7.346 6.00002 9 6.00002C10.654 6.00002 12 7.34602 12 9.00002C12 10.654 10.654 12 9 12C7.346 12 6 10.654 6 9.00002ZM26 23C26 24.654 24.654 26 23 26C21.346 26 20 24.654 20 23C20 21.346 21.346 20 23 20C24.654 20 26 21.346 26 23ZM26 9.00002C26 10.654 24.654 12 23 12C21.346 12 20 10.654 20 9.00002C20 7.34602 21.346 6.00002 23 6.00002C24.654 6.00002 26 7.34602 26 9.00002Z" />
	</svg>
);

export default OrganisationConnection;
